var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NotificationType } from '../../../services/basics/notification-client.service';
import { BaseTemplate } from './base-template';
import { activationStrategy } from 'aurelia-router';
import { IFramePostMessages } from '../../../models/modules/lotteryplatform-client.models';
import * as Enumerable from 'linq';
import { DialogServiceConstants } from '../../../constants/basics/dialog.constants';
import { RouterConstants } from '../../../configuration/router.constants';
import { computedFrom } from 'aurelia-binding';
import { MobileHelper } from '../../../helpers/mobile-helper';
var BaseInstantGame = /** @class */ (function (_super) {
    __extends(BaseInstantGame, _super);
    function BaseInstantGame(lotteryClientService, router, tokenClientService, notificationClientService, i18N, dialogClientService, bindingSignaler, gamePlayerTicketClientService, requestClient, navigationClientService) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClientService) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.tokenClientService = tokenClientService;
        _this.notificationClientService = notificationClientService;
        _this.bindingSignaler = bindingSignaler;
        _this.gamePlayerTicketClientService = gamePlayerTicketClientService;
        _this.requestClient = requestClient;
        _this.navigationClientService = navigationClientService;
        _this.discountOffers = [];
        _this.showIframe = false;
        _this.checkPrevTransaction = false;
        _this.monitorInactivity = function (x) {
            clearTimeout(_this.timer);
            _this.setTimeoutTimer();
        };
        _this.chanceOfWinning = 0;
        _this.isFullscreen = false;
        _this.defaultUserCurrencySymbol = tokenClientService.getUserCurrency().symbol;
        return _this;
    }
    Object.defineProperty(BaseInstantGame.prototype, "showFlipAnimation", {
        get: function () {
            return this.enableFlipAnimation;
        },
        enumerable: false,
        configurable: true
    });
    BaseInstantGame.prototype.setTimeoutTimer = function () {
        var _this = this;
        var twentyMinsInMs = 1200000;
        this.timer = setTimeout(function () {
            _this.clearReloeadCookie();
            _this.closeDialog();
        }, twentyMinsInMs);
    };
    BaseInstantGame.prototype.setReloadFlag = function () {
        localStorage.setItem(IFramePostMessages.reloadPage, JSON.stringify({
            action: "openDialog",
            instantGame: this.instantGame,
            transactionId: this.transactionId
        }));
        this.setTimeoutTimer();
    };
    BaseInstantGame.prototype.resumeGame = function () {
        this.setReloadFlag();
        this.numberOfTries = this.instantGameUserPlayInfoViewModel.numberOfTries - this.instantGameUserPlayInfoViewModel.noOfInstantGamesPlayed;
        this.showIframe = true;
    };
    BaseInstantGame.prototype.endGame = function () {
        var _this = this;
        this.lotteryClientService.markTransactionAsEnded(this.transactionId).then(function (x) {
            _this.dialogClient.hide();
        });
    };
    BaseInstantGame.prototype.shouldScrollTopOnLoad = function () {
        return this.tokenClientService.isPreview;
    };
    Object.defineProperty(BaseInstantGame.prototype, "displayAsPortrait", {
        get: function () {
            if (this.instantGame) {
                return this.instantGame.displayAsPortrait;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    BaseInstantGame.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    Object.defineProperty(BaseInstantGame.prototype, "origin", {
        get: function () {
            return window.location.origin;
        },
        enumerable: false,
        configurable: true
    });
    BaseInstantGame.prototype.activate = function (params) {
        var _this = this;
        var promise = _super.prototype.activate.call(this, params);
        this.key = params.key;
        if (params) {
            this.brandInstantGameId = params.brandInstantGameId;
            this.instantGameId = params.instantGameId;
        }
        if (params && params.tries) {
            this.tries = params.tries;
        }
        if (params && params.canRevert) {
            this.canRevert = params.canRevert;
        }
        var instantGamePromise = this.lotteryClientService.getClientInstantGame({
            brandInstantGameId: this.brandInstantGameId,
            instantGameId: this.instantGameId
        }).then(function (instantGameResult) {
            _this.instantGame = instantGameResult;
            _this.brandInstantGameId = instantGameResult.brandInstantGameId;
            _this.lotteryClientService.getInstantGameUserPlayInfo({ instantGameId: _this.instantGameId, gamePlayerId: _this.tokenClient.user.gamePlayerId }).then(function (x) {
                var existingInstantGameTransaction = Enumerable.from(x).firstOrDefault();
                if (existingInstantGameTransaction != null) {
                    if (params && params.transactionId) {
                        _this.transactionId = params.transactionId;
                    }
                    else {
                        _this.transactionId = existingInstantGameTransaction.transactionId;
                    }
                    _this.instantGameUserPlayInfoViewModel = existingInstantGameTransaction;
                    _this.resumeGame();
                }
                _this.checkPrevTransaction = true;
            });
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
        return new Promise(function (resolve, reject) { return Promise.all([promise, instantGamePromise]).then(function (x) { return resolve(); }, reject); });
    };
    Object.defineProperty(BaseInstantGame.prototype, "pageHeight", {
        get: function () {
            if (this._pageHeight) {
                return this._pageHeight;
            }
        },
        enumerable: false,
        configurable: true
    });
    BaseInstantGame.prototype.attached = function () {
        var _this = this;
        _super.prototype.attached.call(this);
        this.brandId = this.tokenClientService.user.brandId;
        this.countryId = this.tokenClientService.getCountryId();
        this.userCurrency = this.tokenClientService.getUserCurrency();
        if (!this.userCurrency)
            this.userCurrency = {
                currencyId: 1,
                currencyRates: null
            };
        this.isAttached = true;
        this.loadInstantGameDetails();
        this._pageHeight = window['screenHeight'];
        window.addEventListener('mousemove', this.monitorInactivity, true);
        window.addEventListener(IFramePostMessages.onScreenChange, function (e) {
            _this._pageHeight = window['screenHeight'];
            if (MobileHelper.isMobileDevice()) {
                if (window.screenOrientation) {
                    _this.checkOrientation(window.screenOrientation);
                }
                else {
                    _this.enableFlipAnimation = false;
                }
            }
        });
        window.addEventListener(IFramePostMessages.onResize, function (e) {
            _this._pageHeight = window['screenHeight'];
        });
        window.addEventListener(IFramePostMessages.onInstantGameClose, function (e) {
            _this.closeDialog();
        });
        setTimeout(function () {
            _this.fullscreenBtn.addEventListener('click', function () {
                var elem = $('.instant-game-iframe')[0];
                if (!elem.fullscreenElement) {
                    elem.requestFullscreen();
                }
                else {
                    if (elem.exitFullscreen) {
                        elem.exitFullscreen();
                    }
                }
            }, true);
        }, 2000);
    };
    BaseInstantGame.prototype.checkOrientation = function (type) {
        if (type == "landscape" || type == "landscape-primary" || type == "landscape-secondary") {
            this.enableFlipAnimation = false;
        }
        else {
            this.enableFlipAnimation = true;
        }
    };
    BaseInstantGame.prototype.detached = function () {
        window.removeEventListener('mousemove', this.monitorInactivity);
    };
    BaseInstantGame.prototype.showGameIframe = function () {
        var _this = this;
        if (this.tokenClientService.isPreview)
            return;
        if (!this.tokenClientService.isAuthenticated && this.requestClient.enableLoginDialog) {
            this.navigationClientService.cache(RouterConstants.RouteNames.Lobby, { instantGameId: this.instantGameId });
            this.dialogClient.show(DialogServiceConstants.URLs.LoginDialog, null);
        }
        else {
            this.isProcessingRequest = true;
            this.gamePlayerTicketClientService.purchaseInstantGameTickets(this.getSelectedOffer().numberOfDraws, this.instantGameId).then(function (x) {
                _this.isProcessingRequest = false;
                _this.notificationClientService.show(_this.i18n.tr("success"), _this.i18n.tr("purchased-tickets-successfully-message-instant-games"), NotificationType.Success);
                _this.transactionId = x;
                _this.showIframe = true;
                _this.setReloadFlag();
            }, function (x) {
                _this.isUnauthorized = x && x.statusCode == 401 && !_this.tokenClientService.user.enableLoginDialog;
                if (x && !_this.isUnauthorized)
                    _this.notificationClientService.show(_this.i18n.tr("notification-error-title"), _this.i18n.tr(x.response), NotificationType.Error);
                _this.isProcessingRequest = false;
            });
        }
    };
    BaseInstantGame.prototype.checkDefaultDiscount = function () {
        var _this = this;
        var discount = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return _this.tries && x.numberOfDraws == _this.tries; });
        var defaultDiscount = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isDefault; });
        if (discount) {
            this.selectOffer(discount, false);
        }
        else if (defaultDiscount) {
            this.selectOffer(defaultDiscount, false);
        }
        else if (this.discountOffers[0]) {
            this.selectOffer(this.discountOffers[0], false);
        }
    };
    BaseInstantGame.prototype.closeDialog = function () {
        var _this = this;
        if (this.instantGame.redirectUrl) {
            // let route = this.router.routes.find(x=>isArray(x.route) && x.route.find(z=>z == this.instantGame.redirectUrl) != null || x.route == this.instantGame.redirectUrl);
            var route = this.router.routes.find(function (r) {
                return Array.isArray(r.route)
                    ? r.route.some(function (z) { return z === _this.instantGame.redirectUrl; })
                    : r.route === _this.instantGame.redirectUrl;
            });
            if (route) {
                this.navigationClientService.setTitle(route.title);
                this.navigationClientService.navigateAndCache(route.name);
            }
        }
        this.dialogClient.hide();
        this.clearReloeadCookie();
    };
    BaseInstantGame.prototype.clearReloeadCookie = function () {
        localStorage.removeItem(IFramePostMessages.reloadPage);
    };
    BaseInstantGame.prototype.loadInstantGameDetails = function () {
        var _this = this;
        if (this.instantGame && this.isAttached && this.brandInstantGameId) {
            var lotteryBrandDiscountsEnumerable = Enumerable.from(this.instantGame.lotteryBrandDiscounts);
            //get the disounts filtered by country id match or null country
            this.discountOffers =
                lotteryBrandDiscountsEnumerable.orderBy(function (x) { return x.countryId; }).where(function (x) { return ((x.countryId == _this.countryId) || (x.countryId == null)); }).orderBy(function (x) { return x.numberOfDraws; }).toArray();
            var lotteryBrandPricesEnumerable = Enumerable.from(this.instantGame.lotteryBrandPrices);
            this.ticketPrice = this.getPrice(lotteryBrandPricesEnumerable);
            this.checkDefaultDiscount();
            this.validateGame();
        }
    };
    BaseInstantGame.prototype.getPrice = function (enumerable) {
        var _this = this;
        var query = enumerable.where(function (x) { return x.currencyId == _this.userCurrency.currencyId; });
        if (query.any(function (x) { return x.countryId == _this.countryId; }))
            query = query.where(function (x) { return x.countryId == _this.countryId; });
        else
            query = query.where(function (x) { return x.countryId == null; });
        query = query.where(function (x) { return x.lotteryJackpotRangeId == null; });
        return query.firstOrDefault();
    };
    //To override for specific login in template
    BaseInstantGame.prototype.onInstantGameDetailsLoaded = function () { };
    BaseInstantGame.prototype.selectOffer = function (item, persistDrawChanges) {
        var _this = this;
        if (persistDrawChanges === void 0) { persistDrawChanges = true; }
        this.discountOffers.forEach(function (x) { return x.isSelected = false; });
        item.isSelected = true;
        this.updateTotalPrice();
        this.selectedOffer = item;
        this.numberOfTries = item.numberOfDraws;
        if (this.currentTimeOut)
            clearTimeout(this.currentTimeOut);
        var time = this.chanceOfWinning / 500;
        if (this.chanceOfWinning < item.chanceOfWinning) {
            var increase = function () { return setTimeout(function () {
                _this.chanceOfWinning++;
                if (_this.chanceOfWinning < item.chanceOfWinning)
                    _this.currentTimeOut = increase();
            }, time); };
            this.currentTimeOut = increase();
        }
        else if (this.chanceOfWinning > item.chanceOfWinning) {
            var decrease = function () { return setTimeout(function () {
                _this.chanceOfWinning--;
                if (_this.chanceOfWinning > item.chanceOfWinning)
                    _this.currentTimeOut = decrease();
            }, time); };
            this.currentTimeOut = decrease();
        }
    };
    BaseInstantGame.prototype.validateGame = function () {
        var draws = Enumerable.from(this.discountOffers).any();
        if (!draws) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-no-draws-set-up"), "", NotificationType.Warning);
            return false;
        }
        else if (!this.ticketPrice) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-prices-not-set-for-your-currency"), "", NotificationType.Warning);
            return false;
        }
        return true;
    };
    BaseInstantGame.prototype.updateTotalPrice = function () {
        this.bindingSignaler.signal('selected-offer-signal');
    };
    BaseInstantGame.prototype.calculateDiscountedTicketPrice = function (discountModel) {
        var discountedRoundedPrice = this.calculateDiscountedPrice(discountModel.discount, this.ticketPrice);
        var finalPrice = Math.round(discountedRoundedPrice * 100) / 100;
        // console.log("Ticket Price: " + this.ticketPrice.price);
        // console.log("Discounted Ticket Price: " + discountedRoundedPrice);
        // console.log("Rounded Nearest Price: " + roundedPrice);
        // console.log("Discounted Final Rounded Ticket Price: " + finalPrice);
        return this.tokenClientService.getCurrencySymbol() + this.roundToTwoDecimalPlaces(finalPrice).toFixed(2);
    };
    BaseInstantGame.prototype.calculateCurrentDiscountedTicketPrice = function () {
        var discountedRoundedPrice = this.calculateDiscountedPrice(this.getSelectedOffer().discount, this.ticketPrice);
        return this.roundToTwoDecimalPlaces(discountedRoundedPrice).toFixed(2);
    };
    BaseInstantGame.prototype.calculateDiscountedPrice = function (discount, priceModel) {
        var roundedPrice = priceModel.price;
        var discountedRoundedPrice = roundedPrice - this.roundToTwoDecimalPlaces((roundedPrice * discount) / 100);
        return discountedRoundedPrice;
    };
    BaseInstantGame.prototype.getStandardTicketPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClientService.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.ticketPrice.price).toFixed(2);
        }
        return "";
    };
    BaseInstantGame.prototype.isLastItem = function (discountModel) {
        var lotteryBrandDiscountModel = Enumerable.from(this.discountOffers).lastOrDefault();
        var isLastItem = lotteryBrandDiscountModel.lotteryBrandDiscountId == discountModel.lotteryBrandDiscountId;
        return isLastItem;
    };
    Object.defineProperty(BaseInstantGame.prototype, "instantGameTries", {
        get: function () {
            return this.numberOfTries;
        },
        enumerable: false,
        configurable: true
    });
    BaseInstantGame.prototype.getSelectedOffer = function () {
        var selected = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isSelected; });
        return selected;
    };
    BaseInstantGame.prototype.calculateTotalPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClientService.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.getDiscountedPrice()).toFixed(2);
        }
        return this.tokenClientService.getCurrencySymbol() + "0.00";
    };
    BaseInstantGame.prototype.getDiscountedPrice = function () {
        var draws = this.getSelectedOffer() ? this.getSelectedOffer().numberOfDraws : 1;
        var discount = this.getSelectedOffer() ? this.getSelectedOffer().discount : 0;
        return this.roundToTwoDecimalPlaces(this.calculateDiscountedPrice(discount, this.ticketPrice) * draws);
    };
    BaseInstantGame.prototype.calculateTotalPriceWithoutDiscountInternal = function () {
        var draws = this.getSelectedOffer() ? this.getSelectedOffer().numberOfDraws : 1;
        return this.roundToTwoDecimalPlaces(this.ticketPrice.price) * draws;
    };
    BaseInstantGame.prototype.calculateTotalPriceWithoutDiscount = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClientService.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.calculateTotalPriceWithoutDiscountInternal()).toFixed(2);
        }
        return this.tokenClientService.getCurrencySymbol() + "0.00";
    };
    BaseInstantGame.prototype.calculateTotalDiscountPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClientService.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.calculateTotalPriceWithoutDiscountInternal() - this.getDiscountedPrice()).toFixed(2);
        }
        return this.tokenClientService.getCurrencySymbol() + "0.00";
    };
    Object.defineProperty(BaseInstantGame.prototype, "totalPrice", {
        get: function () {
            var _this = this;
            if (this.ticketPrice) {
                var ticketCurrency = Enumerable.from(this.tokenClientService.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
                var calculatedAmount = this.getDiscountedPrice();
                return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(calculatedAmount).toFixed(2);
            }
            return this.tokenClientService.getCurrencySymbol() + "0.00";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseInstantGame.prototype, "pricePerCard", {
        get: function () {
            var _this = this;
            if (this.ticketPrice) {
                var ticketCurrency = Enumerable.from(this.tokenClientService.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
                var price = this.roundToTwoDecimalPlaces(this.selectedOffer ? this.getDiscountedPrice() / this.selectedOffer.numberOfDraws : this.getDiscountedPrice()).toFixed(2);
                return ticketCurrency.symbol + price;
            }
            return this.tokenClientService.getCurrencySymbol() + "0.00";
        },
        enumerable: false,
        configurable: true
    });
    BaseInstantGame.prototype.roundToTwoDecimalPlaces = function (x) {
        // 0.075 with the .toFixed does not round correctly
        return Math.round(x * 100) / 100;
    };
    BaseInstantGame.prototype.showFullscreen = function () {
        this.isFullscreen = !this.isFullscreen;
        window.parent.postMessage({
            event: IFramePostMessages.onIFrameRequestFullscreen,
            detail: {
                isFullscreen: this.isFullscreen
            }
        }, "*");
    };
    __decorate([
        computedFrom("enableFlipAnimation"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseInstantGame.prototype, "showFlipAnimation", null);
    __decorate([
        computedFrom("instantGame", "instantGame.displayAsPortrait", "enableFlipAnimation"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseInstantGame.prototype, "displayAsPortrait", null);
    __decorate([
        computedFrom("_pageHeight"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseInstantGame.prototype, "pageHeight", null);
    __decorate([
        computedFrom("numberOfTries"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseInstantGame.prototype, "instantGameTries", null);
    __decorate([
        computedFrom("ticketPrice", "selectedOffer"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseInstantGame.prototype, "totalPrice", null);
    __decorate([
        computedFrom("ticketPrice", "selectedOffer"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseInstantGame.prototype, "pricePerCard", null);
    return BaseInstantGame;
}(BaseTemplate));
export { BaseInstantGame };
